export default angular
  .module('app.holding.dashboard.messages')
  .filter('holdingStripHtml', holdingStripHtml)
  .name;

function holdingStripHtml() {
  'ngInject';

  return (input) => {
    const div = angular.element('<div></div>');
    div.html(input);
    return div.text().replace(/<\/?[^>]+>/g, '');
  };
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/messages/filters/strip-html.js